"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtils = void 0;
var moment = __importStar(require("moment-timezone"));
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    DateUtils.getNow = function (timeZone) {
        if (timeZone) {
            return moment.tz(timeZone);
        }
        return moment.utc();
    };
    /**
     * rounds the current date to the next interval, considering intervals of `interval` that start at minute `minute`
     *
     * example:
     * - `nextInterval(10, 4)` at '2023-01-01T00:03:00Z' returns `2023-01-01T00:04:00Z`
     * - `nextInterval(10, 4)` at '2023-01-01T00:05:00Z' returns `2023-01-01T00:14:00Z`
     */
    DateUtils.nextInterval = function (interval, intervalStartMinute) {
        if (intervalStartMinute === void 0) { intervalStartMinute = 0; }
        return DateUtils.roundToNextIntervalOnMinute(moment.utc(), interval, intervalStartMinute);
    };
    /**
     * rounds the given date to the next interval, considering intervals of `interval` that start at the minute `intervalStartMinute` of the interval
     *
     * example:
     * - `roundToNextIntervalOnMinute('2023-01-01T00:03:00Z', 10, 4)` returns `2023-01-01T00:04:00Z`
     * - `roundToNextIntervalOnMinute('2023-01-01T00:05:00Z', 10, 4)` returns `2023-01-01T00:14:00Z`
     */
    DateUtils.roundToNextIntervalOnMinute = function (date, interval, intervalStartMinute) {
        var intervalsPassed = Math.floor(date.minute() / interval);
        var minuteInCurrentInterval = date.minute() % interval;
        var intervalsSinceHour = intervalsPassed + (minuteInCurrentInterval >= intervalStartMinute ? 1 : 0);
        return date
            .clone()
            .startOf('hour')
            .add(intervalsSinceHour * interval + intervalStartMinute, 'minute');
    };
    DateUtils.toTimeInCurrentWeekWithTimeZone = function (minutesInWeek, weekOffset, timeZone) {
        if (weekOffset === void 0) { weekOffset = 0; }
        if (timeZone === void 0) { timeZone = 'utc'; }
        var now = moment.tz(timeZone);
        return this.toTimeInWeekWithTimeZone(now, minutesInWeek, weekOffset, timeZone);
    };
    DateUtils.toTimeInWeekWithTimeZone = function (date, minutesInWeek, weekOffset, timeZone) {
        if (weekOffset === void 0) { weekOffset = 0; }
        if (timeZone === void 0) { timeZone = 'utc'; }
        var minutesInHour = minutesInWeek % 60;
        var hoursInWeek = minutesInWeek / 60;
        var roundedHoursInWeek = Math.floor(hoursInWeek);
        var daysInWeek = roundedHoursInWeek / 24;
        var hourInDay = roundedHoursInWeek % 24;
        var roundedDaysInWeek = Math.floor(daysInWeek);
        var dayInMonth = DateUtils.getDayFromWeek(date, roundedDaysInWeek, weekOffset, timeZone);
        return moment.tz([dayInMonth.year(), dayInMonth.month(), dayInMonth.date(), hourInDay, minutesInHour], timeZone);
    };
    DateUtils.getDayFromWeek = function (date, numOfDayInWeek, weekOffset, timeZone) {
        return date.clone().tz(timeZone).startOf('isoWeek').add(weekOffset, 'weeks').add(numOfDayInWeek, 'days');
    };
    return DateUtils;
}());
exports.DateUtils = DateUtils;
//# sourceMappingURL=date_utils.js.map